import { Box, FormControl, Typography } from '@material-ui/core';
import PasswordWarningText from 'components-v2/atoms/PasswordWarningText';
import { Button, Input } from 'components/atoms';
import { useAuth } from 'context';
import React, { useEffect, useState } from 'react';
import { FormDataUtils } from 'utils';
import CircleTimer from '../CircleTimer';
import styles from './styles.module.css';

const ForgetPasswordFormV2 = React.memo(
  ({
    className,
    onClickPhoneForm,
    onClickNewPasswordForm,
    step,
    onTimeout,
    isTimeOut,
    setIsTimeOut,
    toggleResend,
    onClose,
    translatePopupAction,
  }) => {
    const { toggleLogin } = useAuth();
    const regExp = /^([0-9]{6,10})\b/;
    const regExpOpt = /^.{6,6}$/;
    // const regExpPw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(^.{8,20}$)/;
    const SECOND_TIMEOUT = 60 * 3; // 5 minutes -> change to 3 minutes

    const [phoneValue, setPhoneValue] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorPhoneMessage, setErrorPhoneMessage] = useState('');

    const [errorOtp, setErrorOtp] = useState(false);
    const [errorOtpMessage, setErrorOtpMessage] = useState('');

    const [pwValue, setPwValue] = useState('');
    const [errorPw, setErrorPw] = useState(false);
    const [errorPwMessage, setErrorPwMessage] = useState('');

    const [errorPwConfirm, setErrorPwConfirm] = useState(false);
    const [errorPwConfirmMessage, setErrorPwConfirmMessage] = useState('');

    const [second, setSecond] = useState(0);

    const handleLoginFunc = () => {
      onClose();
      toggleLogin();
    };

    // handle validate
    const validatePhone = (data) => {
      setErrorPhone(false);
      if (data === '') {
        setErrorPhone(true);
        setErrorPhoneMessage(translatePopupAction('forgetpassword_step2.entered_numberPhone'));
        return false;
      }
      if (!data.match(regExp)) {
        setErrorPhone(true);
        setErrorPhoneMessage(
          translatePopupAction('popup-trial-account.error_wrong_format_phone_number'),
        );
        return false;
      }
      return true;
    };

    const validateOtp = (data) => {
      setErrorOtp(false);
      if (data === '') {
        setErrorOtp(true);
        setErrorOtpMessage(translatePopupAction('forgetpassword_step2.enter_otp'));
        return false;
      }
      if (!data.match(regExpOpt)) {
        setErrorOtp(true);
        setErrorOtpMessage(translatePopupAction('forgetpassword_step2.opt_have_6_num'));
        return false;
      }
      return true;
    };

    const validatePw = (data) => {
      setErrorPw(false);
      if (data === '') {
        setErrorPw(true);
        setErrorPwMessage(translatePopupAction('popup_login.validate_password_empty'));
        return false;
      }
      if (data.length > 30 || data.length < 8) {
        setErrorPw(true);
        setErrorPwMessage(
          translatePopupAction(
            'popup-validateUntil.password_must_be_entered_min2_and_max30_character',
          ),
        );
        return false;
      }
      return true;
    };

    const validatePwConfirm = (data) => {
      setErrorPwConfirm(false);
      if (data === '') {
        setErrorPwConfirm(true);
        setErrorPwConfirmMessage(
          translatePopupAction('forgetpassword_step2.enter_confirm_password'),
        );
        return false;
      }
      if (data !== pwValue) {
        setErrorPwConfirm(true);
        setErrorPwConfirmMessage(
          translatePopupAction('forgetpassword_step2.wrong_confirm_password'),
        );
        return false;
      }
      return true;
    };

    // handle submit form
    const onSubmitPhoneForm = (e) => {
      e.preventDefault();
      const data = FormDataUtils.convert(e);
      setPhoneValue(data.phoneNumber);
      if (!validatePhone(data.phoneNumber)) {
        return;
      }
      // data type is customer on web
      data.type = 'CUSTOMER';
      data.setErrorPhone = () => setErrorPhone(true);
      data.setErrorPhoneMessage = () =>
        setErrorPhoneMessage(
          translatePopupAction('popup-trial-account.error_wrong_format_phone_number'),
        );
      onClickPhoneForm(data);
    };

    const onSubmitNewPasswordForm = (e) => {
      e.preventDefault();
      const data = FormDataUtils.convert(e);
      if (!validateOtp(data.token)) {
        return;
      }
      if (!validatePw(data.newPassword) || !validatePwConfirm(data.confirmPassword)) {
        return;
      }
      delete data.confirmPassword;
      // data type is customer on web
      data.type = 'CUSTOMER';
      data.setErrorOtp = () => setErrorOtp(true);
      data.setErrorOtpMessage = () =>
        setErrorOtpMessage(translatePopupAction('change-password.err_entered_OTP'));
      onClickNewPasswordForm(data);
    };

    // handle input
    const handleOnChangePhone = (e) => {
      e.preventDefault();
      validatePhone(e.target.value);
    };
    const handleOnChangeOpt = (e) => {
      e.preventDefault();
      validateOtp(e.target.value);
    };

    const handleOnChangePw = (e) => {
      e.preventDefault();
      setPwValue(e.target.value);
      validatePw(e.target.value);
    };

    const handleOnChangePwConfirm = (e) => {
      e.preventDefault();
      validatePwConfirm(e.target.value);
    };

    const startCoundown = (time) => {
      setSecond(time);
      setIsTimeOut(false);
    };

    const onResend = () => {
      startCoundown(SECOND_TIMEOUT);
      onClickPhoneForm({ phoneNumber: phoneValue, type: 'CUSTOMER' });
    };

    useEffect(() => {
      if (step === 2) {
        startCoundown(SECOND_TIMEOUT);
      }
    }, [toggleResend]);

    useEffect(() => {
      const timer = setTimeout(() => {
        if (second > 0) {
          setSecond(second - 1);
          // setMinute(Math.floor(second / 60));
        }
        if (second === 0) {
          onTimeout();
        }
      }, 1000);
      // Clear timeout if the component is unmounted
      return () => clearTimeout(timer);
    }, [second]);

    return (
      <div className={className}>
        {step === 1 && (
          <div>
            <div className={styles.desc}>{translatePopupAction('forgetpassword.sub_title')}</div>
            <form className={className} onSubmit={onSubmitPhoneForm}>
              <FormControl fullWidth>
                <Input
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder={translatePopupAction('forgetpassword.description')}
                  variant="outlined"
                  className={styles.input}
                  error={errorPhone}
                  onChange={handleOnChangePhone}
                />
                <div className={styles.error}>{errorPhone && errorPhoneMessage}</div>
              </FormControl>
              <PasswordWarningText className={styles.mb_10} />
              <Box className={styles.center}>
                <Button type="submit" className={styles.btn}>
                  {translatePopupAction('forgetpassword.send')}
                </Button>
              </Box>
            </form>
          </div>
        )}
        {step === 2 && (
          <div>
            <div className={styles.desc}>{translatePopupAction('forgetpassword_step2.title')}</div>
            <form className={className} onSubmit={onSubmitNewPasswordForm}>
              <div className={styles.timing_wrapper}>
                {!isTimeOut ? (
                  <>
                    {/* <div className={styles.timing}>{second}</div> */}
                    <CircleTimer duration={second} />
                  </>
                ) : (
                  <Button className={styles.btn} onClick={onResend}>
                    {translatePopupAction('forgetpassword_step2.send')}
                  </Button>
                )}
              </div>
              <FormControl fullWidth>
                <Input
                  id="phoneNumber"
                  name="phoneNumber"
                  type="number"
                  placeholder={translatePopupAction('forgetpassword_step2.entered_numberPhone')}
                  variant="outlined"
                  className={[styles.input, styles.disabled]}
                  value={phoneValue}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <Input
                  className={styles.input}
                  id="token"
                  name="token"
                  text="text"
                  placeholder={translatePopupAction('forgetpassword_step2.enter_otp')}
                  variant="outlined"
                  error={errorOtp}
                  onChange={handleOnChangeOpt}
                />
                {errorOtp && <div className={styles.error}>{errorOtpMessage}</div>}
              </FormControl>
              <FormControl fullWidth>
                <Input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  placeholder={translatePopupAction('forgetpassword_step2.enter_new_password')}
                  variant="outlined"
                  className={styles.input}
                  error={errorPw}
                  onChange={handleOnChangePw}
                />
                {errorPw && <div className={styles.error}>{errorPwMessage}</div>}
              </FormControl>
              <FormControl fullWidth>
                <Input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  placeholder={translatePopupAction('forgetpassword_step2.confirm_password')}
                  variant="outlined"
                  error={errorPwConfirm}
                  className={styles.input}
                  onChange={handleOnChangePwConfirm}
                />
                <div className={styles.error}>{errorPwConfirm && errorPwConfirmMessage}</div>
              </FormControl>
              <Box className={styles.center}>
                <Button type="submit" className={styles.btn}>
                  {translatePopupAction('forgetpassword.confirm_reset_password')}
                </Button>
              </Box>
            </form>
          </div>
        )}

        {(step === 3 || step === 4) && (
          <div>
            <div className={styles.confirm_modal_wrap}>
              <div>
                <div className={styles.warning_icon}>
                  <Typography className={styles.text_icon}>✓</Typography>
                </div>
                <Typography className={styles.modal_title}>
                  {translatePopupAction('forgetpassword_step3.changePassword_success')}
                </Typography>
              </div>
            </div>
            <Box className={styles.center}>
              <Button className={styles.btn} onClick={handleLoginFunc}>
                {translatePopupAction('forgetpassword_step3.login')}
              </Button>
            </Box>
          </div>
        )}
      </div>
    );
  },
);
export default ForgetPasswordFormV2;
